import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MessageDesignPicker from './MessageDesignPicker';
import MessageEditor from './MessageEditor';
import Modal from '../Modal/Modal';
import ScrollLock from 'react-scrolllock';

export default class MessageModal extends Component {
    constructor() {
        super();
        this.state = {
            isEditorVisible: false
        };
    }

    componentDidMount() {
        if (!this.props.messageDesign || this.props.messageDesign === '') {
            this.setState({ isEditorVisible: false });
        } else {
            this.setState({ isEditorVisible: true });
        }
    }

    findMessageDesign() {
        let found = {};
        this.props.availableMessageDesigns.map(design => {
            if (
                design.title === this.props.messageDesign ||
                design.id === this.props.messageDesign
            ) {
                found = design;
            }
        });
        return found;
    }

    handleDesignChange = (design, isPremium) => {
        if (design === '') {
            this.setState({ isEditorVisible: false });
        } else {
            this.setState({ isEditorVisible: true });
        }

        this.props.onChange({
            messageDesign: design,
            isMessagePremium: isPremium
        });
    };

    handleDesignRemove = () => {
        this.setState({ isEditorVisible: false });

        this.props.onChange({
            messageDesign: null,
            isMessagePremium: false
        });
    };

    handleMessageSave = data => {
        this.props.onChange(data);
        this.props.onClose();
    };

    renderEditor() {
        if (!this.state.isEditorVisible)
            return (
                <MessageDesignPicker
                    availableMessageDesigns={this.props.availableMessageDesigns}
                    selectedDesign={this.props.messageDesign}
                    currency={this.props.currency}
                    onDesignSelected={this.handleDesignChange}
                    onClose={this.props.onClose}
                />
            );

        const foundDesign = this.findMessageDesign(this.props.messageDesign);

        return (
            <MessageEditor
                message={this.props.message}
                image={this.props.image}
                front={this.props.front}
                onMessageChange={this.props.onMessageChange}
                onSave={this.handleMessageSave}
                onRemove={this.handleDesignRemove}
                messageDesign={foundDesign}
            />
        );
    }

    render() {
        return (
            <ScrollLock>
                <Modal isOpen={true} size={'large'} onClose={this.props.onClose}>
                    {this.renderEditor()}
                </Modal>
            </ScrollLock>
        );
    }
}

MessageModal.defaultProps = { messageDesign: '' };

MessageModal.propTypes = {
    availableMessageDesigns: PropTypes.array,
    messageDesign: PropTypes.string,
    message: PropTypes.string,
    image: PropTypes.string,
    front: PropTypes.string,
    currency: PropTypes.string,
    onChange: PropTypes.func,
    onClose: PropTypes.func
};
